import React, { useState } from "react"
import Layout from "../components/layoutSubMenu"
import { GatsbyImage } from "gatsby-plugin-image"
import Seo from "../components/seo"
import { graphql } from "gatsby"
import Menu from "../components/menu"
import SubMenu from "../components/sub-menu"
import ReiseHero from "../components/reise-hero"
import PreiseTermine from "../components/preise-termine"
import Reiseverlauf from "../components/reiseverlauf"
import FruehbucherRabatt from "../components/fruehbucher-rabatt"
import Einzelzimmer from "../components/einzelzimmer-preis"
import BeiAllenReisenInkludiert from "../components/bei-allen-reisen-inkludiert"
import EntdeckenSieMehr from "../components/entdecken-sie-mehr"
import Buchungsanfrage from "../components/buchungsanfrage/buchungsanfrage"
import { useMediaQuery } from "react-responsive"

const Segelkreuzfahrt = ({ data, pageContext }) => {
  let [isOpen, setIsOpen] = useState(false)
  const isMobile = useMediaQuery({ query: "(max-width: 735px)" })

  function closeModal() {
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  return (
    <Layout>
      <Menu subMenu={true} />
      <SubMenu
        reisentyp={data.contentfulReise.typ}
        destination={data.contentfulReise.destination}
        isOpen={isOpen}
        openModal={openModal}
        closeModal={closeModal}
        showBuchenButton={data.contentfulReise.preiseUndTermine}
      />
      <Seo title={data.contentfulReise.destination} />

      <ReiseHero
        title={[
          // <span className="flagge">{data.contentfulReise.flagge}</span>,
          // " ",
          data.contentfulReise.land,
        ]}
        img={{
          ...data.contentfulReise.heroImage.gatsbyImageData,
          aspectRatio: 4 / 3,
        }}
      />
      <h1 className="reise-headline">{data.contentfulReise.destination}</h1>
      <h3 className="reise-kurzbeschreibung">
        {data.contentfulReise.kurzbeschreibung}
      </h3>

      <section className="reise-beschreibung-background">
        <div className="reise-beschreibung-container">
          {!isMobile && (
            <div className="float-right">
              <div className="preise-termine preise-termine-segelkreuzfahrt">
                <div className="termine">
                  <h3 className="preise-termine-headline">Preise & Termine</h3>
                  <FruehbucherRabatt
                    rabatt={data.contentfulReise.fruehbucherRabatt}
                  />
                  <table>
                    <PreiseTermine
                      preiseUndTermine={data.contentfulReise.preiseUndTermine}
                      destination={data.contentfulReise.destination}
                    />
                    {data.contentfulReise.preiseUndTermine && (
                      <Einzelzimmer
                        textEinzelzimmer={
                          data.contentfulReise.textEinzelzimmer ||
                          "Einzelzimmer"
                        }
                        preisEinzelzimmer={
                          data.contentfulReise.preisEinzelzimmer
                        }
                      />
                    )}
                  </table>
                </div>
                <div className="leistungen">
                  <h3 className="preise-termine-headline">Leistungen</h3>
                  <div
                    className="leistungen-bullets"
                    dangerouslySetInnerHTML={{
                      __html:
                        data.contentfulReise.leistungen.childMarkdownRemark
                          .html,
                    }}
                  ></div>
                </div>
                {data.contentfulReise.preiseUndTermine && (
                  <Buchungsanfrage
                    reise={data.contentfulReise}
                    isOpen={isOpen}
                    openModal={openModal}
                    closeModal={closeModal}
                    typ="segelkreuzfahrt"
                  />
                )}
              </div>
              {data.contentfulReise.operatedBy &&
                data.contentfulReise.operator && (
                  <div className="info-box-operator">
                    <div className="reise-hinweise mx-1 flex gap-1 align-middle justify-center flex-col">
                      <span className="self-center">
                        {data.contentfulReise.operatedBy}
                      </span>
                      <div className="mt-2 flex flex-row gap-1 justify-center">
                        {data.contentfulReise.operator.image.gatsbyImageData ? (
                          <GatsbyImage
                            image={
                              data.contentfulReise.operator.image
                                .gatsbyImageData
                            }
                            alt={data.contentfulReise.operator.name}
                          />
                        ) : (
                          <img
                            className="m-0 p-0 max-h-[30px]"
                            src={data.contentfulReise.operator.image.file.url}
                            alt={data.contentfulReise.operator.name}
                            height={30}
                          ></img>
                        )}
                        <span className="self-center">
                          <strong>{data.contentfulReise.operator.name}</strong>
                        </span>
                      </div>
                    </div>
                  </div>
                )}

              <div className="info-box">
                <div
                  className="reise-hinweise"
                  dangerouslySetInnerHTML={{
                    __html:
                      data.contentfulReise.hinweise.childMarkdownRemark.html,
                  }}
                ></div>
              </div>
            </div>
          )}
          <div className="reise-beschreibung">
            <img
              alt="Segelkreuzfahrt"
              className="reise-icon"
              src={data.contentfulReise.icon.file.url}
            ></img>
            <div
              className="reise-beschreibung-text"
              dangerouslySetInnerHTML={{
                __html:
                  data.contentfulReise.beschreibung.childMarkdownRemark.html,
              }}
            ></div>

            {isMobile && (
              <div className="float-right">
                <div className="preise-termine preise-termine-segelkreuzfahrt">
                  <div className="termine">
                    <h3 className="preise-termine-headline">
                      Preise & Termine
                    </h3>
                    <FruehbucherRabatt
                      rabatt={data.contentfulReise.fruehbucherRabatt}
                    />
                    <table>
                      <PreiseTermine
                        preiseUndTermine={data.contentfulReise.preiseUndTermine}
                        destination={data.contentfulReise.destination}
                      />
                      {data.contentfulReise.preiseUndTermine && (
                        <Einzelzimmer
                          textEinzelzimmer={
                            data.contentfulReise.textEinzelzimmer ||
                            "Einzelzimmer"
                          }
                          preisEinzelzimmer={
                            data.contentfulReise.preisEinzelzimmer
                          }
                        />
                      )}
                    </table>
                  </div>
                  <div className="leistungen">
                    <h3 className="preise-termine-headline">Leistungen</h3>
                    <div
                      className="leistungen-bullets"
                      dangerouslySetInnerHTML={{
                        __html:
                          data.contentfulReise.leistungen.childMarkdownRemark
                            .html,
                      }}
                    ></div>
                  </div>
                  {data.contentfulReise.preiseUndTermine && (
                    <Buchungsanfrage
                      reise={data.contentfulReise}
                      isOpen={isOpen}
                      openModal={openModal}
                      closeModal={closeModal}
                      typ="segelkreuzfahrt"
                    />
                  )}
                </div>
                {data.contentfulReise.operatedBy &&
                  data.contentfulReise.operator && (
                    <div className="info-box-operator">
                      <div className="reise-hinweise mx-1 flex gap-1 align-middle justify-center flex-col">
                        <span className="self-center">
                          {data.contentfulReise.operatedBy}
                        </span>
                        <div className="mt-2 flex flex-row gap-1 justify-center">
                          {data.contentfulReise.operator.image
                            .gatsbyImageData ? (
                            <GatsbyImage
                              image={
                                data.contentfulReise.operator.image
                                  .gatsbyImageData
                              }
                              alt={data.contentfulReise.operator.name}
                            />
                          ) : (
                            <img
                              className="m-0 p-0 max-h-[30px]"
                              src={data.contentfulReise.operator.image.file.url}
                              alt={data.contentfulReise.operator.name}
                              height={30}
                            ></img>
                          )}
                          <span className="self-center">
                            <strong>
                              {data.contentfulReise.operator.name}
                            </strong>
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                <div className="info-box">
                  <div
                    className="reise-hinweise"
                    dangerouslySetInnerHTML={{
                      __html:
                        data.contentfulReise.hinweise.childMarkdownRemark.html,
                    }}
                  ></div>
                </div>
              </div>
            )}

            <h3>Reiseverlauf</h3>
            <Reiseverlauf reiseverlauf={data.contentfulReise.reiseverlauf} />
          </div>
        </div>
      </section>
      <section className="gallery">
        {data.contentfulReise.weitereBilder.map((bild, index) => (
          <GatsbyImage
            alt={bild.description}
            key={index}
            image={{ ...bild.gatsbyImageData, aspectRatio: 1 }}
            className="gallery-image"
          />
        ))}
      </section>
      <section>
        <BeiAllenReisenInkludiert
          buchenMoeglich={data.contentfulReise.preiseUndTermine ?? false}
          isOpen={isOpen}
          openModal={openModal}
          closeModal={closeModal}
          typ="segelkreuzfahrt"
        />
      </section>
      <EntdeckenSieMehr reisen={data.contentfulReise.entdeckenSieMehr} />
    </Layout>
  )
}

export const query = graphql`
  query ($slug: String!) {
    contentfulReise(slug: { eq: $slug }) {
      destination
      typ
      land
      flagge
      linkZurBuchung
      kurzbeschreibung
      beschreibung {
        childMarkdownRemark {
          html
        }
      }
      hinweise {
        childMarkdownRemark {
          html
        }
      }
      operatedBy
      operator {
        name
        image {
          gatsbyImageData(height: 30, layout: CONSTRAINED)
          file {
            url
          }
        }
      }
      preisEinzelzimmer
      textEinzelzimmer
      heroImage {
        gatsbyImageData(layout: CONSTRAINED, aspectRatio: 1.77, quality: 100)
      }
      weitereBilder {
        description
        gatsbyImageData(layout: FULL_WIDTH)
      }
      icon {
        file {
          url
        }
      }
      preiseUndTermine {
        beschreibung
        preis
        fullTermin: termin(formatString: "dddd, DD. MMMM YYYY", locale: "de")
        termin(formatString: "DD.MM")
        fullEnde: ende(formatString: "dddd, DD. MMMM YYYY", locale: "de")
        ende(formatString: "DD.MM.YYYY")
        einzelzimmerPreis
      }
      leistungen {
        id
        childMarkdownRemark {
          html
        }
      }
      fruehbucherRabatt {
        childMarkdownRemark {
          html
        }
      }
      schwierigkeit {
        schwierigkeit
        beschreibung {
          childMarkdownRemark {
            html
          }
        }
        kondition {
          childMarkdownRemark {
            html
          }
        }
        trittsicherheit {
          childMarkdownRemark {
            html
          }
        }
      }
      reiseverlauf {
        title
        text {
          childMarkdownRemark {
            html
          }
        }
      }
      entdeckenSieMehr {
        typ
        land
        slug
        destination
        heroImage {
          gatsbyImageData(width: 200, height: 200, layout: FIXED)
        }
      }
    }
  }
`

export default Segelkreuzfahrt
